import React from "react";

const LoanImg = ({ color }) => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 14.5564C9 15.6341 9.83333 16.5008 10.8556 16.5008H12.9444C13.8333 16.5008 14.5556 15.7453 14.5556 14.8008C14.5556 13.7897 14.1111 13.423 13.4556 13.1897L10.1111 12.023C9.45556 11.7897 9.01112 11.4341 9.01112 10.4119C9.01112 9.47858 9.73333 8.71191 10.6222 8.71191H12.7111C13.7333 8.71191 14.5667 9.57858 14.5667 10.6564"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7773 7.61182V17.6118"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22.6118C17.5228 22.6118 22 18.1346 22 12.6118C22 7.08897 17.5228 2.61182 12 2.61182C6.47715 2.61182 2 7.08897 2 12.6118C2 18.1346 6.47715 22.6118 12 22.6118Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LoanImg;
